module.exports = __webpack_public_path__ + "assets/Plus-white.2b4c99058872845cf7abc1e10e93d1c4.svg";